import { BaseDTO } from '../global/base.dto';
import { QualificationListDTO } from '../qualification/qualification-list.dto';
import { ResourceGroupListDTO } from '../resource-group/resource-group-list.dto';

export class ResourceDTO extends BaseDTO {

    name: string;

    description: string;

    resourceGroups: Array<ResourceGroupListDTO>;

    qualifications: Array<QualificationListDTO>;    

}
